import * as React from "react";
import {
  Typography, Button, TextField,
  FormControl, InputLabel, Select, MenuItem,
  Table, TableBody, TableCell, TableHead, TableRow, TableContainer,
  Checkbox, Box
} from "../../components/mui";
import {
  SearchRoundedIcon, RestartAltRoundedIcon, GetAppRoundedIcon, PeopleAltRoundedIcon
} from "../../components/icons";

import "../../styles/main.css";
import "../../styles/pages/stayInEmployees.css";
import PageLayout from "../../components/shared/PageLayout";
import PageHeader from "../../components/shared/PageHeader";
import DataTableCard from "../../components/shared/DataTableCard";

// Hardcoded filter options - Backend developer will replace with API calls
const FILTER_OPTIONS = {
  condo: [
    { value: "all", label: "All" },
    { value: "island-plaza-salcedo", label: "Island Plaza Salcedo" },
    { value: "oriental-kh", label: "Oriental KH" },
    { value: "jazz-residences", label: "Jazz Residences" }
  ],
  condoUnit: [
    { value: "all", label: "All" }
  ],
  condoCompany: [
    { value: "all", label: "All" },
    { value: "avantico-carp", label: "Avantico Carp" },
    { value: "caspo", label: "Caspo" },
    { value: "concerto", label: "Concerto" }
  ],
  condoSharing: [
    { value: "all", label: "All" },
    { value: "not-shared", label: "Not Shared" },
    { value: "shared", label: "Shared" }
  ],
  company: [
    { value: "all", label: "All" },
    { value: "avantico-carp", label: "Avantico Carp" },
    { value: "caspo-inc", label: "Caspo Inc" }
  ],
  division: [
    { value: "all", label: "All" },
    { value: "operations-business-support", label: "Operations & Business Support" },
    { value: "product-branding", label: "Product & Branding (Asia)" },
    { value: "business-intelligence", label: "Business Intelligence" },
    { value: "customer-relations", label: "Customer Relations" }
  ],
  department: [
    { value: "all", label: "All" },
    { value: "payment-accounting", label: "[409] Payment & Accounting Support" },
    { value: "marketing", label: "[418] Marketing (VN)" },
    { value: "business-intelligence", label: "[132] Business Intelligence" },
    { value: "product", label: "[408] Product" },
    { value: "customer-relations", label: "[154] Customer Relations" }
  ],
  team: [
    { value: "all", label: "All" },
    { value: "ea-deposit", label: "EA Deposit" },
    { value: "sea-vietnam", label: "SEA Vietnam" },
    { value: "business-intelligence", label: "Business Intelligence" },
    { value: "product", label: "Product" },
    { value: "ea-china", label: "EA China" },
    { value: "team-2a", label: "Team 2a" }
  ],
  nationality: [
    { value: "all", label: "All" },
    { value: "indonesian", label: "Indonesian" },
    { value: "vietnamese", label: "Vietnamese" },
    { value: "burmese", label: "Burmese" },
    { value: "thai", label: "Thai" },
    { value: "malaysian", label: "Malaysian" },
    { value: "chinese", label: "Chinese" }
  ],
  designation: [
    { value: "all", label: "All" },
    { value: "executive", label: "Executive" },
    { value: "senior-executive", label: "Senior Executive" },
    { value: "operations-analyst", label: "Operations Analyst" }
  ]
};

// Hardcoded employee data - Backend developer will replace with API calls
const EMPLOYEE_DATA = [
  {
    id: 1561,
    eid: "1561",
    fullName: "Ferna Jeshyana",
    condo: "Island Plaza Salcedo",
    condoUnit: "9-A Island Plaza",
    gender: "F",
    nickname: "Ferna",
    ranking: "0",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Operations & Business Support",
    department: "[409] Payment & Accounting Support",
    team: "EA Deposit",
    nationality: "Indonesian",
    onBoardDate: "01/01/2001",
    condoCompany: "Caspo",
    condoSharing: "Not Shared"
  },
  {
    id: 1562,
    eid: "1562",
    fullName: "Thi Anh Thu Tran",
    condo: "Island Plaza Salcedo",
    condoUnit: "9-A Island Plaza",
    gender: "F",
    nickname: "Amie",
    ranking: "0",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Nanels & Branding (Asia)",
    department: "[418] Marketing (VN)",
    team: "SEA Vietnam",
    nationality: "Vietnamese",
    onBoardDate: "01/01/2001",
    condoCompany: "Caspo",
    condoSharing: "Not Shared"
  },
  {
    id: 1563,
    eid: "1563",
    fullName: "Sanon Jenhem",
    condo: "Island Plaza Salcedo",
    condoUnit: "10-A Island Plaza",
    gender: "M",
    nickname: "S1",
    ranking: "0",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Product & Branding (Asia)",
    department: "[408] Product",
    team: "Product",
    nationality: "Thai",
    onBoardDate: "01/01/2001",
    condoCompany: "Avantico",
    condoSharing: "Not Shared"
  },
  {
    id: 1564,
    eid: "1564",
    fullName: "Min Khant Maung Maung",
    condo: "Island Plaza Salcedo",
    condoUnit: "10-A Island Plaza",
    gender: "M",
    nickname: "Michael",
    ranking: "0",
    designation: "Senior Executive",
    company: "Avantico Carp",
    division: "Business Intelligence",
    department: "[132] Business Intelligence",
    team: "Business Intelligence",
    nationality: "Burmese",
    onBoardDate: "01/01/2001",
    condoCompany: "Avantico",
    condoSharing: "Not Shared"
  },
  {
    id: 1598,
    eid: "1598",
    fullName: "Uyen Phuong Duong Tran",
    condo: "Island Plaza Salcedo",
    condoUnit: "9-A Island Plaza",
    gender: "F",
    nickname: "Uyen",
    ranking: "0",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Operations & Business Support",
    department: "[154] Customer Relations",
    team: "ACX",
    nationality: "Vietnamese",
    onBoardDate: "01/01/2001",
    condoCompany: "Caspo",
    condoSharing: "Not Shared"
  },
  {
    id: 1599,
    eid: "1599",
    fullName: "Yong Yang Tan",
    condo: "Island Plaza Salcedo",
    condoUnit: "10-A Island Plaza",
    gender: "M",
    nickname: "Vincent",
    ranking: "0",
    designation: "Executive",
    company: "Avantico Carp",
    division: "Operations & Business Support",
    department: "[154] Customer Relations",
    team: "EA China",
    nationality: "Malaysian",
    onBoardDate: "01/01/2001",
    condoCompany: "Avantico",
    condoSharing: "Not Shared"
  },
  {
    id: "CN043",
    eid: "CN043",
    fullName: "Ye Ye Lu",
    condo: "HY Center Apartment",
    condoUnit: "2923 HY Center Apartment",
    gender: "M",
    nickname: "Lu",
    ranking: "0",
    designation: "Operations Analyst",
    company: "Caspo Inc",
    division: "Operations Management",
    department: "Straight",
    team: "Team 2a",
    nationality: "Chinese",
    onBoardDate: "01/01/2001",
    condoCompany: "Concerto",
    condoSharing: "Not Shared"
  }
];

function StayInEmployeesSelectFilter({ label, optionKey, value, onChange }) {
  const options = FILTER_OPTIONS[optionKey] || [];

  return (
    <FormControl size="small" className="stay-in-filter">
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={onChange} label={label}>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

function StayInEmployeesFilterActions({ onReset }) {
  return (
    <Box className="stay-in-toolbar stay-in-toolbar--filters">
      <Button variant="contained" startIcon={<SearchRoundedIcon />}>
        Search
      </Button>
      <Button variant="outlined" startIcon={<RestartAltRoundedIcon />} onClick={onReset}>
        Reset filters
      </Button>
      <Button variant="outlined" startIcon={<GetAppRoundedIcon />}>
        Export
      </Button>
    </Box>
  );
}

/**
 * Overall Stay-in Employees Page Component
 * UI/Layout only - Backend developer will add:
 * - API calls for fetching employee data
 * - Filter functionality
 * - Search functionality
 * - Pagination logic
 * - Export functionality
 */
export default function StayInEmployees({ onLogout, onNavigate }) {
  // Filter state
  const [filters, setFilters] = React.useState({
    nameEid: "",
    condo: "all",
    condoUnit: "all",
    condoCompany: "all",
    condoSharing: "all",
    company: "all",
    division: "all",
    department: "all",
    team: "all",
    nationality: "all",
    designation: "all"
  });

  const handleFilterChange = (field) => (event) => {
    setFilters({
      ...filters,
      [field]: event.target.value
    });
  };

  const handleReset = () => {
    setFilters({
      nameEid: "",
      condo: "all",
      condoUnit: "all",
      condoCompany: "all",
      condoSharing: "all",
      company: "all",
      division: "all",
      department: "all",
      team: "all",
      nationality: "all",
      designation: "all"
    });
  };

  return (
    <PageLayout activeKey="stay-in-employees" onLogout={onLogout} onNavigate={onNavigate} className="page-content">
      <PageHeader
        icon={PeopleAltRoundedIcon}
        title="Overall Stay-in Employees"
        summary="View and manage all stay-in employees across all condo units."
      />

      {/* Filters */}
      <Box className="content-box stay-in-filters">
        {/* Row 1 - 6 columns */}
        <Box className="stay-in-filters-row">
          <TextField
            size="small"
            label="Name / EID"
            placeholder="Search by name or EID"
            className="stay-in-filter"
            value={filters.nameEid}
            onChange={handleFilterChange("nameEid")}
          />
          <StayInEmployeesSelectFilter 
            label="Condo" 
            optionKey="condo" 
            value={filters.condo}
            onChange={handleFilterChange("condo")}
          />
          <StayInEmployeesSelectFilter 
            label="Condo Unit" 
            optionKey="condoUnit" 
            value={filters.condoUnit}
            onChange={handleFilterChange("condoUnit")}
          />
          <StayInEmployeesSelectFilter 
            label="Condo Company" 
            optionKey="condoCompany" 
            value={filters.condoCompany}
            onChange={handleFilterChange("condoCompany")}
          />
          <StayInEmployeesSelectFilter 
            label="Condo Sharing" 
            optionKey="condoSharing" 
            value={filters.condoSharing}
            onChange={handleFilterChange("condoSharing")}
          />
          <StayInEmployeesSelectFilter 
            label="Designation" 
            optionKey="designation" 
            value={filters.designation}
            onChange={handleFilterChange("designation")}
          />
        </Box>

        {/* Row 2 - 6 columns */}
        <Box className="stay-in-filters-row">
          <StayInEmployeesSelectFilter 
            label="Company" 
            optionKey="company" 
            value={filters.company}
            onChange={handleFilterChange("company")}
          />
          <StayInEmployeesSelectFilter 
            label="Division" 
            optionKey="division" 
            value={filters.division}
            onChange={handleFilterChange("division")}
          />
          <StayInEmployeesSelectFilter 
            label="Department" 
            optionKey="department" 
            value={filters.department}
            onChange={handleFilterChange("department")}
          />
          <StayInEmployeesSelectFilter 
            label="Team" 
            optionKey="team" 
            value={filters.team}
            onChange={handleFilterChange("team")}
          />
          <StayInEmployeesSelectFilter 
            label="Nationality" 
            optionKey="nationality" 
            value={filters.nationality}
            onChange={handleFilterChange("nationality")}
          />
          <div className="stay-in-filter" />
        </Box>

        {/* Actions row under filters */}
        <StayInEmployeesFilterActions onReset={handleReset} />
      </Box>

      {/* Data Table */}
      <DataTableCard
        title="Employee Records"
        showExport={false}
        totalEntries={EMPLOYEE_DATA.length}
        startEntry={1}
        endEntry={EMPLOYEE_DATA.length}
        currentPage={1}
        totalPages={1}
      >
        <TableContainer className="data-table-wrapper">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>EID</TableCell>
                <TableCell>Full Name</TableCell>
                <TableCell>Condo</TableCell>
                <TableCell>Condo Unit</TableCell>
                <TableCell>Gender</TableCell>
                <TableCell>Nickname</TableCell>
                <TableCell>Ranking</TableCell>
                <TableCell>Designation</TableCell>
                <TableCell>Company</TableCell>
                <TableCell>Division</TableCell>
                <TableCell>Department</TableCell>
                <TableCell>Team</TableCell>
                <TableCell>Nationality</TableCell>
                <TableCell>On Board Date</TableCell>
                <TableCell>Condo Company</TableCell>
                <TableCell>Condo Sharing</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {EMPLOYEE_DATA.map((employee) => (
                <TableRow hover key={employee.id}>
                  <TableCell>{employee.eid}</TableCell>
                  <TableCell>{employee.fullName}</TableCell>
                  <TableCell>{employee.condo}</TableCell>
                  <TableCell>{employee.condoUnit}</TableCell>
                  <TableCell>{employee.gender}</TableCell>
                  <TableCell>{employee.nickname}</TableCell>
                  <TableCell>{employee.ranking}</TableCell>
                  <TableCell>{employee.designation}</TableCell>
                  <TableCell>{employee.company}</TableCell>
                  <TableCell>{employee.division}</TableCell>
                  <TableCell>{employee.department}</TableCell>
                  <TableCell>{employee.team}</TableCell>
                  <TableCell>{employee.nationality}</TableCell>
                  <TableCell>{employee.onBoardDate}</TableCell>
                  <TableCell>{employee.condoCompany}</TableCell>
                  <TableCell>{employee.condoSharing}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DataTableCard>
    </PageLayout>
  );
}
